// extracted by mini-css-extract-plugin
module.exports = {"headerText":"HeaderIntroText_headerText__3Hw52"};